import BaseModel from './BaseModel'
import {action, computed, makeObservable, observable} from 'mobx'

export default class Company extends BaseModel {
  constructor(store) {
    super(store);
    makeObservable(this, {
      id: observable,
      name: observable,
      owner_phone: observable,
      address: observable,
      sports: observable,
      location: observable,
      is_valid: computed,
      parent_id: observable,
      was_validated: observable,
      validate: action
    })
  }
  
  id = 0;
  name = '';
  owner_phone = '';
  address = '';
  sports = [];
  location = null;
  parent_id = null;
  was_validated = false;

  get is_valid() {
    return this.name && this.owner_phone && this.address && this.sports.length > 0 && this.location;
  }

  validate() {
    this.was_validated = true;
    let isValid = this.name && this.address && this.sports.length > 0 && this.location;
    if (!this.parent_id) {
      isValid = isValid && this.owner_phone
    }
    console.log('validate company', isValid, this)
    return isValid
  }
}